export const TABLE_RESERVATION_COLUMN_WIDTHS = {
    ageCategories: 136,
    room: 112,
    preferences: 96,
    status: 128,
    time: 104,
    actions: 72,
} as const;
